import React, { useEffect, useState } from 'react';
import { FamilyMember, FamilyMemberStatus } from 'types/censusService';
import ICensusReviewPageStore, { CensusReviewDomainParams } from 'store/modules/census/iCensusReviewPageStore';
import { observer } from 'mobx-react-lite';
import { TableBody } from '@insurancemenu/imenu-components-lib';
import { ErrorsToggleStyled, SectionWrapperStyled, TableStyled, TableTitleStyled, TableWrapperStyled } from './styles';
import CensusTableHeader from './TableHeader';
import CensusTableRow from './TableRow';
import { CENSUS_TABLE_TEST_ID, CENSUS_TABLE_TOGGLE_TEST_ID } from '../../constants';

interface Props {
  pageStore: ICensusReviewPageStore<CensusReviewDomainParams>;
}

const CensusTable: React.FC<Props> = observer(({ pageStore }) => {
  const { hasFamiliesWithErrors, families, headers, isLoading } = pageStore;
  const [showOnlyRowsWithErrors, setShowOnlyRowsWithErrors] = useState(true);

  useEffect(() => {
    if (!hasFamiliesWithErrors) {
      setShowOnlyRowsWithErrors(false);
    }
  }, [hasFamiliesWithErrors]);

  const filterRowsWithErrors = (): void => {
    setShowOnlyRowsWithErrors(!showOnlyRowsWithErrors);
  };

  const moreThanOneFile = !!families?.find((family) => family[0].row.includes('2-'));

  return (
    <SectionWrapperStyled data-test-id={CENSUS_TABLE_TEST_ID}>
      <TableTitleStyled>Imported Census</TableTitleStyled>
      {hasFamiliesWithErrors && (
        <ErrorsToggleStyled
          checked={showOnlyRowsWithErrors}
          onChange={filterRowsWithErrors}
          labelActive="Show Only Errors"
          labelInactive="Show Only Errors"
          fixedLabelSide="right"
          data-test-id={CENSUS_TABLE_TOGGLE_TEST_ID}
        />
      )}
      <TableWrapperStyled>
        <TableStyled
          loading={isLoading}
          maxHeight="55rem"
          minHeight="10rem"
          totalElements={families?.flat().length ?? 0}
          $columnsAmount={headers.length}
        >
          <CensusTableHeader headers={headers} />
          <TableBody>
            {families?.map((family, familyIndex) => {
              return family
                .filter(({ status }) => !showOnlyRowsWithErrors || status === FamilyMemberStatus.INVALID)
                .map((familyMember: FamilyMember, cellIndex: number): React.ReactNode => {
                  return (
                    <CensusTableRow
                      key={familyMember.row}
                      familyMember={familyMember}
                      familyIndex={familyIndex}
                      cellIndex={cellIndex}
                      isMoreThanOneFile={moreThanOneFile}
                      isLastFamilyMember={cellIndex === family.length - 1}
                    />
                  );
                });
            })}
          </TableBody>
        </TableStyled>
      </TableWrapperStyled>
    </SectionWrapperStyled>
  );
});
export default CensusTable;
